/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Create pair with bank information for fiat deposit instruction
 */
export interface RowData {
  key: string;
  value?: string;
}
